import $ from "jquery";
import "select2";

const select2 = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    // Searchable selects only; plain selects are <c-form.field> selects.
    const el = {
      main: ".js-select2",
    };

    if ($(el.main).length === 0) return;

    // Inside a modal the dropdown goes into the <dialog>: the modal is in the
    // top layer, above anything appended to <body>.
    $(window).on("load", function () {
      $(el.main).each(function () {
        const dialog = $(this).closest("dialog");
        $(this).select2(dialog.length ? { dropdownParent: dialog } : {});
      });
    });
  };
  init();
};

try {
  select2();
} catch (error) {
  console.error("select2", error);
}
